import { render, staticRenderFns } from "./ShortText.vue?vue&type=template&id=0d11da78&scoped=true&"
import script from "./ShortText.vue?vue&type=script&lang=js&"
export * from "./ShortText.vue?vue&type=script&lang=js&"
import style0 from "./ShortText.vue?vue&type=style&index=0&id=0d11da78&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d11da78",
  null
  
)

export default component.exports